import { ActionTypes } from '../constants/index';

export const getPaymentManagement = (payload: any) => ({
  type: ActionTypes.PAYMENT_MANAGEMENT_LIST_REQUEST,
  payload,
});
